module.exports = __webpack_public_path__ + "media/images/shared/icon-background-check-aecf0dba010527eedcdc9d5e0d1628e8.png";